import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import MainPage from './components/MainPage'
import LoginPage from './components/LoginPage'

Vue.config.productionTip = false
Vue.use(BootstrapVue)

const routes = {
  '/login': LoginPage
}

// const NotFound = { template: '<h1>Not found</h1>' }

const app = new Vue({
  el: '#app',
  data: {
    currentRoute: window.location.pathname
  },
  computed: {
    ViewComponent () {
      return routes[this.currentRoute] || MainPage
    }
  },
  render (h) { return h(this.ViewComponent) }
})

window.addEventListener('popstate', () => {
  app.currentRoute = window.location.pathname
})



// WEBPACK FOOTER //
// ./src/main.js